import React, {useContext, useRef, useState} from "react";
import {useForm} from "react-hook-form";
import CreateSearchCategories from "./CreateSearchCategories";
import CreateSearchAbout from "./CreateSearchAbout";
import CreateSearchTime from "./CreateSearchTime";

import moment from "moment";
import DeviceContext from "../../../../store/device-context";
import AuthContext from "../../../../store/auth-context";
import axios from "axios";
import {link} from "../../../../store/host-store";
import {token} from "../../../../App";
import {useNavigate} from "react-router-dom";
import CreateAdsCity from "../../../../adRole/ads/createAds/CreateAdsCity";
import {RegistratorBlock} from "../../registratorBlock/registratorBlock";
import Loader from "../../../../components/loader/Loader";
import {calendarAction} from "../../../../store/redux";
import ErrorFormModal from "../../../../UI/Modal/ErrorFormModal";
import {useDispatch} from "react-redux";


const CreateSearchForm = ({type}) => {
    const device = useContext(DeviceContext);
    const ctx = useContext(AuthContext)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [errorBlock, setErrorBlock] = useState(false)
    const [elementId, setElementId] = useState([0]);
    const editorRefAbout = useRef(null);
    const [loading, setLoading] = useState(false)
    const [arrayCityId, setArrayCityId] = useState([]);
    const [categoryParent, setCategoryParent] = useState(null);
    const [rerender, setRerender] = useState(false);
    const [categoryChild, setCategoryChild] = useState(null);
    const [disabled, setDisabled] = useState(false);
    const [haveSubCategories, setHaveSubCategories] = useState(0);
    const [images, setImages] = useState([]);
    const {register, handleSubmit} = useForm();
    const [date, setDate] = useState(new Date(new Date().setDate(new Date().getDate() + 90)));
    const [cityId, setCityIid] = useState("");
    const [errors, setErrors] = useState({});
    const [registratorData, setRegistratorData] = useState({
        tel: '',
        name: '',
    });
    const [imagesAvatar, setImagesAvatar] = useState([]);
    const [activeStatus, setActiveStatus] = useState();

    function showErrors(errorList) {
        setErrors([]);
        if (errorList.status === 400 || errorList.status === 500){
            setErrors((prevState) => ({ ...prevState, image: errorList }));
        }
        errorList.map((error) => {
            switch (error.field) {
                case "name":
                    setErrors((prevState) => ({ ...prevState, name: error }));
                    break;
                case "model":
                    setErrors((prevState) => ({ ...prevState, model: error }));
                    break;
                case "about":
                    setErrors((prevState) => ({ ...prevState, about: error }));
                    break;
                case "category_id":
                    setErrors((prevState) => ({ ...prevState, category: error }));
                    break;
                case "city_id":
                    setErrors((prevState) => ({ ...prevState, city_id: error }));
                    break
                case "contactPhone":
                    setErrors((prevState) => ({ ...prevState, contactPhone: error }));
                    break;
                default:
            }
        });
    }


    const onSubmit = (data) => {
        setDisabled(true);
        let cities = [...new Set(arrayCityId.filter(Boolean))];
        let category_id = categoryChild === null ? "" : categoryChild.value;
        let selected_images = images.length === 0 ? null : images;
        let dates = moment(date).format('YYYY-MM-DD') + " " +  data.time + ':00'

        if (+type === 2 && haveSubCategories.length === 0) {
            category_id = categoryParent.value;
        }


        const formData = new FormData();
        formData.append("seek", 1);
        formData.append("category_id", category_id);
        formData.append("type", type);
        formData.append("name", data.name);
        formData.append("about", editorRefAbout.current);
        {
            selected_images === null
                ? formData.append("image", null)
                :
                selected_images.forEach((file) => {
                    formData.append("image[]", file);
                });
        }
        formData.append("final_date", dates);
        formData.append("user_id", ctx.isUserId);
        if(cities.length > 0){
            cities.map(item => formData.append('cities[]', item))
        }
        if(ctx.userData?.account?.role === 'registrar'){
            formData.append('contactName', registratorData.name)
            formData.append('contactPhone', registratorData.tel)
            formData.append('contactAvatar', imagesAvatar[0])
        }
        if(activeStatus !== undefined){
            formData.append('type_activity', activeStatus?.value)
        }

        const sendRequest = async () => {
            setLoading(true);
            setDisabled(true);

            try {
                const response = await axios.post(`${link}/object`, formData, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                        Authorization: token,
                    },
                });

                if (response.data.success) {
                    navigate('/lc/advertisement');
                    setLoading(false);
                } else {
                    showErrors(response.data.data);
                    setDisabled(false);
                    setLoading(false);
                }
            } catch (error) {
                setDisabled(false);
                setLoading(false);

                if (error.response.status === 400 || error.response.status === 500) {
                    showErrors(error.response.data);
                } else {
                    setErrorBlock(true);
                    console.error("Ошибка при отправке запроса:", error);
                }
            } finally {
                await ctx.setRerender((prev) => !prev);
                setLoading(false)
            }
        };
        sendRequest();
    }

    const getCity = (city) => {
        setCityIid(city?.value)
        setDisabled(false);
    };

    return(
        <form className="form_cabinet_create" onSubmit={handleSubmit(onSubmit)}>
        <div className="create_ads__center">
            <div className="create_ads__box">
                {ctx.userData?.account?.role === 'registrar' &&
                <RegistratorBlock
                    setRegistratorData={setRegistratorData}
                    registratorData={registratorData}
                    setImagesAvatar={setImagesAvatar}
                    id={'registrar'}
                    imagesAvatar={imagesAvatar}
                    error={errors}
                />
                }
                <div className="create_ads_t_block create_ads_border">
                    <div className="advers___title">Что Вам нужно:</div>
                    <CreateSearchCategories
                        setCategoryParent={setCategoryParent}
                        categoryParent={categoryParent}
                        setCategoryChild={setCategoryChild}
                        categoryChild={categoryChild}
                        type={type}
                        setHaveSubCategories={setHaveSubCategories}
                        haveSubCategories={haveSubCategories}
                        errors={errors}
                        activeStatus={activeStatus}
                        setActiveStatus={setActiveStatus}
                    />
                </div>
                <div>
                    <CreateSearchAbout register={register} editorRefAbout={editorRefAbout} setImages={setImages} images={images} errors={errors} error={errors.image?.message}/>
                </div>

                <CreateSearchTime register={register} setDate={setDate} date={date} errors={errors}/>

                <div className="create_ads_border">
                    <div className="advers___title">Место оказания услуги: </div>
                    <div className="create_ads__box">
                        {/*<CitySelects getCity={getCity} />*/}
                        {elementId.map((el, i) =>
                            <CreateAdsCity getCity={getCity} key={el} arrayCityId={arrayCityId}
                                           index={i}
                                           elementId={elementId}
                                           setRerender={setRerender}
                                           setElementId={setElementId}/>
                        )
                        }
                    </div>
                    <p className="error">{errors.city_id?.message}</p>
                </div>

            </div>
            <div className="cabinet_ads__left">
                {loading ? (
                    <div style={{ height: '120px' }}>
                        <Loader />
                    </div>
                ) : (
                    <button
                        disabled={disabled}
                        type="submit"
                        className="btn_publish btn_save"
                    >
                        Разместить объявление
                    </button>
                )}
            </div>
            {errorBlock &&
                <div className={"modal__overlay"}>
                        <span
                            className="modal__close"
                            onClick={async () => {
                                await dispatch(calendarAction.closeCalendar());
                                await document.querySelector('body').classList.remove('noscroll')
                            }}></span>
                    <ErrorFormModal/>
                </div>
            }
        </div>
        </form>
    )
}

export default CreateSearchForm;